<template>
  <div class="product-container">
    <div class="category mb-10 bs-10 br-10">
      <h2><em>Case Category</em></h2>
      <el-divider />
      <div class="title">
        <el-row :gutter="10">
          <el-col :span="4" v-for="(type,index) in types" :key="index">
            <el-button @click="handleTypeClick(type)" style="width: 100%;">{{type.casesType}}</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
    <!--div class="h-5"></div-->
    <div>
      <div class="image-box mb-10 bs-10 br-10">
        <img ref='i1' :src="prevImage" :style="{left:prevLeft}" style="display: inline-block;height: 600px;" />
        <img ref='i2' :src="currentImage" :style="{left:currentLeft}" style="display: inline-block;height: 600px;" />
        <img ref='i3' :src="nextImage" :style="{left:nextLeft}" style="display: inline-block;height: 600px;" />
      </div>
      <!--el-image :src="datas.length>0?datas[currentIndex].url:''" :fit="fit" class="mb-10 bs-10 br-10 db" style="height:675px"></el-image-->
      <div class="image-container">
        <div class="left"><i class="el-icon-arrow-left arrow" @click="moveCarousel(-1)" :disabled="atEndOfList"></i></div>
        <div class="image-warp">
          <div class="df" :style="{ transform: 'translateX' + '(' + currentOffset + 'px' + ')'}">
            <div v-for="(item,index3) in datas" :key="index3" @click="showImage(index3)">
              <el-image :src="item.url" :fit="fit" :alt="index3" class="br-10" style="width:135px;height:100px;cursor:pointer;margin-right: 5px;"></el-image>
            </div>
          </div>

        </div>
        <div class="right"><i class="el-icon-arrow-right arrow" @click="moveCarousel(1)" :disabled="atHeadOfList"></i></div>
      </div>
    </div>
    <div class="h-60"></div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        types: {},
        datas: {},
        casesId: '',
        currentIndex: 0,
        windowSize: 8,
        currentOffset: 0,
        moveOffset: 135,
        //atEndOfList: false,
        //atHeadOfList: false,
        ishow: false,
        current: 0, //当前操作按钮
        fit: 'fit',
        prevLeft: '-100%',
        currentLeft: '0',
        nextLeft: '100%',
        prevImage:'',
        currentImage:'',
        nextImage:'',
      }
    },
    methods: {
      moveCarousel(direction) {
        // Find a more elegant way to express the :style. consider using props to make it truly generic
        if (direction === 1 && !this.atEndOfList) {
          this.currentOffset -= this.moveOffset;
        } else if (direction === -1 && !this.atHeadOfList) {
          this.currentOffset += this.moveOffset;
        }
        console.log(this.currentOffset);
      },
      showImage(index){
        this.currentIndex = index;

        if(this.$refs.i3.style.left == '100%' && this.currentImage !== this.datas[index].url){
          this.nextImage = this.datas[index].url;
          this.$refs.i2.style.transition = 'all 0.5s';
          this.$refs.i2.style.left = '-100%';
          this.$refs.i3.style.transition = 'all 0.5s';
          this.$refs.i3.style.left = '0px';
          this.$refs.i1.style.transition = 'none';
          this.$refs.i1.style.left = '100%';
        }else if(this.$refs.i3.style.left == '0px' && this.nextImage !== this.datas[index].url){
          this.prevImage = this.datas[index].url;
          this.$refs.i3.style.transition = 'all 0.5s';
          this.$refs.i3.style.left = '-100%';
          this.$refs.i1.style.transition = 'all 0.5s';
          this.$refs.i1.style.left = '0px';
          this.$refs.i2.style.transition = 'none';
          this.$refs.i2.style.left = '100%';
        }else if(this.$refs.i3.style.left == '-100%' && this.prevImage !== this.datas[index].url){
          this.currentImage = this.datas[index].url;
          this.$refs.i1.style.transition = 'all 0.5s';
          this.$refs.i1.style.left = '-100%';
          this.$refs.i2.style.transition = 'all 0.5s';
          this.$refs.i2.style.left = '0px';
          this.$refs.i3.style.transition = 'none';
          this.$refs.i3.style.left = '100%';
        }
      },
      getTpye() {
        this.$axios.get('/api/casestype').then(res => {
            console.log(res.data);
            if (res.data.code == '0') {
              this.types = res.data.data;
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          })
          .catch(function(error) { // 请求失败处理
            console.log(error);
          });
      },
      getData() {
        //debugger
        let url;
        if (this.casesId != undefined) {
          url = '/api/cases/' + this.casesId;
        } else {
          this.$router.push({ name: 'Case', params: {  }});
        }
        this.$axios.get(url).then(res => {
            console.log(res.data);
            if (res.data.code == '0') {
              this.datas = res.data.data[0].imageList;
              this.prevImage = this.datas[0].url;
              this.currentImage = this.datas[0].url;
              this.nextImage = this.datas[0].url;
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error'
              })
            }
          })
          .catch(function(error) { // 请求失败处理
            console.log(error);
          });
      },
      handleTypeClick(item){
        console.log(item);
        this.$router.push({ name: 'CaseCategory', params: { id: item.id }});
      },
    },
    computed: {
      atEndOfList() {
        return this.currentOffset <= (this.moveOffset * -1) * (this.datas.length - this.windowSize);
      },
      atHeadOfList() {
        return this.currentOffset === 0;
      },
    },
    mounted: function() {
      this.casesId = this.$route.params.id;
      console.log('pid : '+this.casesId);
      this.getTpye();
      this.getData();
    }
  }
</script>

<style scoped>
  .image-box {
    /* transition: all .5s; */
    position: relative;
    height: 600px;
    margin-bottom: 10px;
    overflow: hidden;
  }
  .image-box img {
    /* transition: all .5s; */
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .product-container {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 50px;
  }

  .category {
    background-color: #fff;
    padding: 0 10px;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .category:after {
    display: block;
    content: '';
    clear: both;
    height: 0;
    overflow: hidden
  }

  .category h2 {
    text-align: center;
  }

  .category h2 em {
    display: block;
    font-size: 20px;
    color: #cecece;
    text-transform: uppercase;
    font-weight: normal;
  }

  .category .title {
    float: left;
    background-color: #FFF;
    width: 100%;
  }

  .category .title button {
    width: 98%;
    margin-bottom: 20px;
  }

  .image-container {
    display: flex;
    justify-content: center;
    width: 1200px;
    height: 100px;
  }

  .image-container .left {
    width: 40px;
    height: 100%;
  }

  .image-container .right {
    width: 40px;
    height: 100%;
  }

  .image-container .image-warp {
    width: 1120px;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;
  }

  .arrow {
    height: 100px;
    line-height: 100px;
    font-size: 48px;
    cursor: pointer;
    /* color: #005500; */
  }

  .df {
    width: 100%;
    display: flex;
  }
  .h-5 {
    height: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/CaseDetail.vue